export default {

}



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/index/queryTotalDeviceNum.js